
import React from 'react';
import { Search, Filter, X } from 'lucide-react';

interface SearchAndFilterProps {
  searchQuery: string;
  onSearchChange: (val: string) => void;
  children?: React.ReactNode;
  placeholder?: string;
}

export const SearchAndFilter: React.FC<SearchAndFilterProps> = ({ 
  searchQuery, 
  onSearchChange, 
  children, 
  placeholder = "Hledat..." 
}) => {
  return (
    <div className="flex flex-col md:flex-row gap-4">
      <div className="relative flex-1">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-300" size={18} strokeWidth={1.5} />
        <input 
          type="text" 
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={placeholder}
          className="h-11 w-full pl-11 pr-10 bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 rounded-xl text-sm text-slate-700 dark:text-slate-200 focus:outline-none focus:border-slate-300 transition-colors placeholder:text-slate-300"
        />
        {searchQuery && (
          <button 
            onClick={() => onSearchChange('')}
            className="absolute right-3 top-1/2 -translate-y-1/2 p-1 text-slate-300 hover:text-slate-500 transition-colors"
          >
            <X size={14} />
          </button>
        )}
      </div>
      
      {children && (
        <div className="flex gap-2 items-center overflow-x-auto pb-1 md:pb-0 custom-scrollbar">
          <Filter size={18} className="text-slate-300 shrink-0 md:hidden" strokeWidth={1.5} />
          {children}
        </div>
      )}
    </div>
  );
};
